/* eslint-disable react/require-default-props */
import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography, Collapse } from '@mui/material';
import CardContainerServices from './serviceTimes/components/CardContainerServices';
import CollapseBox from './CollapseBox';
import { Destination } from '../../utils/types/ProjectType';

interface Props {
  destinations: Destination[];
  detailProjectId: string;
  projectType: string;
}

const ProjectsTimeList: React.FC<Props> = function ProjectsTimeList({
  detailProjectId,
  projectType,
  destinations
}) {
  const [openDestination, setOpenDestination] = useState<{
    [destinationId: string]: boolean;
  }>({});
  const [openServiceId, setOpenServiceId] = useState<number | null>(null);

  useEffect(() => {
    if (destinations?.length > 0) {
      const firstDestinationId = String(destinations[0].id);
      setOpenDestination({ [firstDestinationId]: true });
    }
    if (
      destinations?.length > 0 &&
      destinations[0].serviceTimes[0].services.length > 0
    ) {
      setOpenServiceId(destinations[0].serviceTimes[0].id);
    }
  }, [destinations]);

  // Ensure only one collapse is open at a time
  const toggleDestination = (destinationId: string) => {
    setOpenDestination((prev) => {
      const isCurrentlyOpen = !!prev[destinationId];
      return { [destinationId]: !isCurrentlyOpen }; // Close others, open new one
    });
  };

  const toggleService = (serviceId: number) => {
    setOpenServiceId((prevId) => (prevId === serviceId ? null : serviceId));
  };

  const headerServiceTme = () => {
    return (
      <Box
        sx={{
          alignItems: 'center',
          background: '#F5F6F8',
          border: '1px solid #E2E4EA',
          borderRadius: '8px',
          display: 'flex',
          gap: 1,
          mb: 1,
          px: 2,
          py: '10px'
        }}
      >
        <i
          className="custom-icon icon-setup"
          style={{ color: '#005DA2', fontSize: 14 }}
        />
        <Typography
          sx={{ color: '#0f1c2e', fontSize: '13px', fontWeight: 700 }}
        >
          {projectType === 'Regular'
            ? 'Service Setup — Regular Time'
            : 'Service Setup — Ad-Hoc'}
        </Typography>
      </Box>
    );
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" flexDirection="column">
        {headerServiceTme()}
      </Box>
      <Box display="flex" flexDirection="column" gap={2}>
        {destinations.map((destination: Destination) => (
          <CollapseBox
            destination={destination}
            isCollapseOpen={openDestination[String(destination.id)]}
            key={destination.id}
            projectSetupTab="serviceSetup"
            toggleDestination={() => toggleDestination(String(destination.id))}
          >
            <Collapse
              unmountOnExit
              in={!!openDestination[String(destination.id)]}
              timeout="auto"
            >
              <Box
                display="flex"
                flexDirection="column"
                gap={2}
                marginTop={2.5}
              >
                {destination &&
                  destination.serviceTimes?.length > 0 &&
                  destination.serviceTimes.map((serviceTime, index: number) => (
                    <CardContainerServices
                      count={`${index + 1}`}
                      data={serviceTime}
                      dayChecked=""
                      detailProjectId={detailProjectId}
                      isOpen={openServiceId === serviceTime.id}
                      key={serviceTime.id}
                      projectType={projectType}
                      setIsOpen={() => toggleService(serviceTime.id)}
                      type="serviceSetup"
                      typeView=""
                      utcUpadtedAt=""
                    />
                  ))}
              </Box>
            </Collapse>
          </CollapseBox>
        ))}
      </Box>
    </Box>
  );
};

export default ProjectsTimeList;
